/*
Template Name: Ubold - Responsive Bootstrap 5 Admin Dashboard
Author: CoderThemes
Website: https://coderthemes.com/
Contact: support@coderthemes.com
File: Main Head Js File
*/

//  RTL support js
if (document.getElementById('app-style').href.includes('rtl.min.css')) {
    document.getElementsByTagName('html')[0].dir = "rtl";
}
